module.exports = __webpack_public_path__ + "img/news1.d03d5cd7.jpg";